export default __webpack_public_path__ + "static/button-green-d6d1014bce1ed5da6c6a163530aa41de.png";